import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { panelCatalogApiRef } from '../api';
import { FeatureRequestFilters } from '@agilelab/plugin-wb-builder-common';

export const useFeatureRequests = (
  projectUrn: string,
  filters: FeatureRequestFilters,
) => {
  const panelCatalogApi = useApi(panelCatalogApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'list', { projectUrn, ...filters }],
    queryFn: () =>
      panelCatalogApi.fetchFeatureRequests({
        projectUrn,
        componentUrn: filters.componentUrn,
        status: filters.status,
        priority: filters.priority,
        offset: filters.offset,
        limit: filters.limit,
      }),
    staleTime: 0,
  });
};
